import { useSyncExternalStore } from "react";

import { getAuth, subscribeAuth, type AuthState } from "@/lib/api/auth";

const BEFORE_START: AuthState = { status: "checking" };

/** Who is signed in, kept up to date. */
export function useAuth(): AuthState {
  return useSyncExternalStore(subscribeAuth, getAuth, () => BEFORE_START);
}
